function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".frame,.primary{fill:none;}.white{fill:#fff;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "frame",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "white"
}, React.createElement("path", {
  className: "white",
  d: "M160.7,151.27h-85l-42.4,18.42V42.26a9.23,9.23,0,0,1,9.25-9.21H160.7A9.23,9.23,0,0,1,170,42.26v99.79A9.24,9.24,0,0,1,160.7,151.27Z"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("path", {
  className: "highlights",
  d: "M122.39,216.15h73.12L232,232V122.36a7.94,7.94,0,0,0-8-7.93H122.39a7.94,7.94,0,0,0-8,7.93v85.86A7.94,7.94,0,0,0,122.39,216.15Z"
}), React.createElement("path", {
  className: "highlights",
  d: "M162.19,149.27H90.86L55.27,164V62.4A7.57,7.57,0,0,1,63,55.05h99.15A7.57,7.57,0,0,1,170,62.4v79.53A7.56,7.56,0,0,1,162.19,149.27Z"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("path", {
  className: "primary",
  d: "M159.61,150.22h-85L32.22,168.64V41.22A9.24,9.24,0,0,1,41.47,32H159.61a9.24,9.24,0,0,1,9.25,9.22V141A9.24,9.24,0,0,1,159.61,150.22Z"
})));
var SvgConversations = function SvgConversations(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConversations, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Conversations.b1e4ca66.svg";
export { ForwardRef as ReactComponent };